module.exports = __webpack_public_path__ + "static/media/jenn.965ad076.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/jenn.jpg
// module id = 606
// module chunks = 0